<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">Create Account</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
</div>
<div class="modal-body">
  <eng-register-form
    [returnUrl]="returnUrl"
    (success)="activeModal.dismiss()"
    (switchToLoginRequested)="openLoginModal()" />
</div>
